// src/hooks/useShopOffersSummary.js
// Lightweight offer summary based on local storage (demo/offline) data.

import { useMemo } from "react";

const LS_OFFERS = "mudoShopOffers";

function readOffers() {
  try {
    const raw = localStorage.getItem(LS_OFFERS);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function useShopOffersSummary() {
  // Offers are stored as { [listingId]: [{status, ts, ...}] }
  const offersByListing = useMemo(() => readOffers(), []);

  const { openOffersCount, staleOffersCount } = useMemo(() => {
    const now = Date.now();
    let openCount = 0;
    let staleCount = 0;

    Object.values(offersByListing || {}).forEach((list) => {
      (Array.isArray(list) ? list : []).forEach((offer) => {
        if (offer.status === "accepted" || offer.status === "declined" || offer.status === "completed") return;
        openCount += 1;
        const created = offer.ts || offer.created_at || offer.createdAt;
        if (created) {
          const ageDays = (now - new Date(created).getTime()) / (1000 * 60 * 60 * 24);
          if (ageDays >= 2) staleCount += 1;
        }
      });
    });

    return { openOffersCount: openCount, staleOffersCount: staleCount };
  }, [offersByListing]);

  return { openOffersCount, staleOffersCount };
}
